export const DOCUMENT_ROOT_PATH = '/app/documents';

const SECTION_SLUGS = {
  institution: 'Документы учреждения',
  education: 'Образование',
  patients: 'Пациентам',
  'paid-services': 'Платные услуги',
  'anti-corruption': 'Противодействие коррупции',
  'special-assessment': 'Специальная оценка условий труда',
};

export function getDocumentSectionName(slug) {
  return SECTION_SLUGS[slug] || slug;
}

export function buildDocumentFolderRequest(routeParams) {
  const { nameFolder, name, nextName } = routeParams;
  const sectionName = getDocumentSectionName(nameFolder);
  let currentPath = `${DOCUMENT_ROOT_PATH}/${sectionName}`;
  let folderName = name;

  if (nextName) {
    currentPath = `${currentPath}/${name}`;
    folderName = nextName;
  }

  return { name: folderName, currentPath };
}
